import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

const ViewUserProject = () => {
    const { projectId } = useParams();
    const [project, setProject] = useState({});
    const [showReviews, setShowReviews] = useState(false);
    const [reviews, setReviews] = useState([]);
    const [errorMessage, setErrorMessage] = useState('');
    const [departments, setDepartments] = useState([]);
    const [contributors, setContributors] = useState([]);

    useEffect(() => {
        if (projectId) {
            fetch(`${process.env.REACT_APP_API_BASE_URL}/api/projects/${projectId}`)
                .then(response => response.json())
                .then(data => setProject(data))
                .catch(error => console.error('Error fetching project details:', error));
        }
    }, [projectId]);

    useEffect(() => {
        if (projectId) {
            fetch(`${process.env.REACT_APP_API_BASE_URL}/api/project-departments/${projectId}`)
                .then(response => response.json())
                .then(data => setDepartments(data.departments))
                .catch(error => console.error('Error fetching project departments:', error));
        }
    }, [projectId]);

    useEffect(() => {
        if (projectId) {
            fetch(`${process.env.REACT_APP_API_BASE_URL}/api/project-contributors/${projectId}`)
                .then(response => response.json())
                .then(data => setContributors(data.contributors))
                .catch(error => console.error('Error fetching project contributors:', error));
        }
    }, [projectId]);

    useEffect(() => {
        if (showReviews) {
            fetch(`${process.env.REACT_APP_API_BASE_URL}/api/reviews/project/${projectId}`)
                .then(response => {
                    if (!response.ok) {
                        throw new Error('Failed to fetch reviews');
                    }
                    return response.json();
                })
                .then(data => setReviews(data))
                .catch(error => {
                    setErrorMessage(error.message);
                    console.error('Error fetching reviews:', error);
                });
        }
    }, [showReviews, projectId]);

    return (
        <div className="container mt-4">
            <div className="card shadow-sm">
                <div className="card-body">
                    {/* Project Details Section */}
                    <h3 className="card-title mb-4">Project Details for {projectId}</h3>
                    <div className="project-details">
                        <p><strong>TRL Level:</strong> {project.trlLevel}</p>
                        <p><strong>Project ID:</strong> {project.projId}</p>
                        <p><strong>Title:</strong> {project.projTitle}</p>
                        <p><strong>Summary:</strong> {project.projSummary}</p>
                        <p><strong>Lab:</strong> {project.labId}</p>
                        <p><strong>Project Type:</strong> {project.projType}</p>
                        <p><strong>Utilization:</strong> {project.projUtilization}</p>
                        <p><strong>Initial Fund:</strong> {project.projInitialFund}</p>
                    </div>

                    {/* Departments List */}
                    <h5>Departments:</h5>
                    <ul className="list-group mt-3">
                        {Array.isArray(departments) && departments.length > 0 ? (
                            departments.map((dept) => (
                                <li key={dept.deptId} className="list-group-item d-flex justify-content-between align-items-center">
                                    {dept.deptId}
                                </li>
                            ))
                        ) : (
                            <li className="list-group-item">No Departments Found</li>
                        )}
                    </ul>

                    {/* Contributors List */}
                    <h5>Contributors:</h5>
                    <ul className="list-group mt-3">
                        {Array.isArray(contributors) && contributors.length > 0 ? (
                            contributors.map((contributor) => (
                                <li key={contributor.userId} className="list-group-item d-flex justify-content-between align-items-center">
                                    {contributor.userId}
                                </li>
                            ))
                        ) : (
                            <li className="list-group-item">No Contributors Found</li>
                        )}
                    </ul>

                    {/* Button to toggle the review table */}
                    <button
                        className="btn btn-primary mt-4"
                        onClick={() => setShowReviews(!showReviews)}
                    >
                        {showReviews ? 'Hide Reviews' : 'View Reviews'}
                    </button>

                    {/* Error message */}
                    {errorMessage && <p className="text-danger mt-3">No review found....</p>}

                    {/* Reviews Table */}
                    {showReviews && (
                        <div className="reviews-table mt-4">
                            <h4>Reviews</h4>
                            <table className="table table-striped table-bordered">
                                <thead className="table-dark">
                                    <tr>
                                        <th>ID</th>
                                        <th>Project ID</th>
                                        <th>Review Date</th>
                                        <th>Comments</th>
                                        <th>Actionable Insights</th>
                                        <th>Rating</th>
                                        <th>Remarks</th>
                                        <th>Reviewed By</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {reviews.map(review => (
                                        <tr key={review.id}>
                                            <td>{review.id}</td>
                                            <td>{review.projId}</td>
                                            <td>{new Date(review.reviewDate).toLocaleDateString()}</td>
                                            <td>{review.comments}</td>
                                            <td>{review.actionableInsights}</td>
                                            <td>{review.rating}</td>
                                            <td>{review.remarks}</td>
                                            <td>{review.reviewedBy}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ViewUserProject;
